export default "__VITE_ASSET__BAB3EWGs__"